import {
  MCP_CREDENTIAL_DIALOG_TOOL_NAME,
  McpCredentialDialogInputSchema,
  McpCredentialDialogOutputSchema,
} from '@terra/shared-dto-chat-types';
import { openMcpConnectionSettings } from './open-mcp-connection-settings';
import {
  parsePortalToolHandlerInput,
  isElectronApiAvailable,
  getElectronApiUnavailableResult,
} from '../portal-tool-handler.utils';
import type { PortalToolHandler } from '../types';

export const mcpCredentialDialogHandler: PortalToolHandler = async ({
  input,
  toolCallId,
  batchId,
  applicationId,
}) => {
  const parsedInput = parsePortalToolHandlerInput({
    schema: McpCredentialDialogInputSchema,
    input,
    toolName: MCP_CREDENTIAL_DIALOG_TOOL_NAME,
    toolCallId,
    batchId,
  });
  if (!parsedInput.ok) {
    return parsedInput.result;
  }

  if (!isElectronApiAvailable()) {
    return getElectronApiUnavailableResult({
      toolName: MCP_CREDENTIAL_DIALOG_TOOL_NAME,
      toolCallId,
      batchId,
    });
  }

  try {
    openMcpConnectionSettings({
      applicationId,
      identityId: parsedInput.data.identityId,
    });

    return {
      status: 'success',
      result: McpCredentialDialogOutputSchema.parse({
        message: 'Opened MCP connection credential settings',
        navigation: {
          tabType: 'settings-mcp-connection',
          openEdit: true,
          identityId: parsedInput.data.identityId,
        },
        data: { opened: true },
      }),
    };
  } catch (error) {
    return {
      status: 'error',
      result: McpCredentialDialogOutputSchema.parse({
        message:
          error instanceof Error
            ? error.message
            : 'Failed to open MCP credential settings',
      }),
    };
  }
};
